import { ButtonComponent } from './styles';
import { FaWhatsapp } from 'react-icons/fa';
import { IconType } from 'react-icons';
import { buildWhatsAppLink } from '../../utils/whatsapp';


export interface ButtonProps {
  text?: string;
  fullWidth?: boolean;
  icon?: IconType;
};

function Button({ text, fullWidth}: ButtonProps) {
  function handleRequestQuote() {
    window.location.href = buildWhatsAppLink();
  }
  return (
    <>
        <ButtonComponent
          fullWidth={fullWidth}
          onClick={handleRequestQuote}
          >
          <FaWhatsapp />

          {text}
        </ButtonComponent>
    </>
  );
}

export default Button;
